<div class="card-body" *ngIf="otpDisable">


  <div class="container-fluid">
    <form (ngSubmit)="otp()" [formGroup]="form">
      <h4>Enter your OTP </h4>
      <div class="row otp-boxes-smallscreens">
        <div class="form-group col-sm-2 col-xs-2 " *ngFor="let input of formInput;  index as i">
          <input #formRow type="text" formControlName="{{input}}" class="form-control otp-border-styles" maxlength="1"
            (keyup)="keyUpEvent($event, i)">
        </div>
      </div>

      <div>
        <div class="row">        

            <div class="col-md" *ngIf="!submit_enable">
                <button type="submit" class="btn btn-primary" [disabled]="click" style="width: 100%;">Submit</button>
              </div>

          <div class="col-md" *ngIf="submit_enable">
            <button type="button" class="btn btn-primary" (click)="submitForgot()" style="width: 100%;">Resend</button>
          </div>

          <div class="col-md timer-styles">
              <countdown [config]="t"></countdown>
            </div>
        </div>
      </div>

    </form>
  </div>
  <br><br>
</div>




<div class="card-body" *ngIf="!otpDisable">

  <div class="form-group">
    <div class="form-row">

      <div class="col-md">
        <label for="passwordNew">New Password</label>
        <show-hide-password size="md" btnStyle="primary" [btnOutline]="false">
          <input type="text" class="form-control" pattern="(?=^.{8,}$)((?=.*\d)|(?=.*\W+))(?![.\n])(?=.*[A-Z])(?=.*[a-z]).*$"
            id="password" name="password" [(ngModel)]="newPswd" ngModel #newref="ngModel">
        </show-hide-password>
        <div *ngIf="newref.errors &&(newref.touched || newref.dirty)" class="alert alert-danger">
          <div [hidden]="!newref.errors?.pattern">
            One Capital, one Small , One Number , Min 8 Charecters
          </div>
        </div>
      </div>
    </div><br> 

    <div class="form-row">

      <div class="col-md">
        <label for="passwordCnf">Confirm Password</label>
        <show-hide-password size="md" btnStyle="primary" [btnOutline]="false">
          <input type="text" class="form-control" pattern="(?=^.{8,}$)((?=.*\d)|(?=.*\W+))(?![.\n])(?=.*[A-Z])(?=.*[a-z]).*$"
            id="cnfpassword" name="cnfpassword" [(ngModel)]="cnfPswd" ngModel #cnfref="ngModel">
        </show-hide-password>
        <div *ngIf="cnfref.errors &&(cnfref.touched || cnfref.dirty)" class="alert alert-danger">
          <div [hidden]="!cnfref.errors?.pattern">
            One Capital, one Small , One Number , Min 8 Charecters
          </div>
        </div>
      </div>

    </div>
    <br><br>
    <div>
      <input type="submit" (click)="forgot()" class="btn btn-primary btn-block" value="Submit" />
    </div>
  </div>
</div>